require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-armadale-residence-featured-in-the-design-institute-of-australia.json") })
        }
      }, "path---journal-armadale-residence-featured-in-the-design-institute-of-australia");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-armadale-residence-featured-in-the-design-institute-of-australia!./.cache/json/journal-armadale-residence-featured-in-the-design-institute-of-australia.json
// module id = 454
// module chunks = 231608221292675